import 'bootstrap/dist/css/bootstrap.css';
import React, {
  useCallback,
  useState,
  useEffect,
  useRef,
} from 'react';
import { resolutionList } from './utils/resolutionMap.js'

function App() {

  const [serialPort, setSerialPort] = useState(null);
  const [vdDevices, setVdDevices] = useState(null);
  const [selectedWidth, setSelectedWidth] = useState('');
  const [selectedHeight, setSelectedHeight] = useState('');
  const [selectedResolution, setSelectedResolution] = useState('');
  const [dvcs, setDvcs] = useState({});
  const [selectedVideoInput, setSelectedVideoInput] = useState('');
  const videoInputRef = useRef();
  const videoInputSelectRef = useRef();

  useEffect(() => {
    const fetchData = async () => {
      try {
        const videoDevice = await navigator.mediaDevices.getUserMedia({ video: true });

        videoDevice.getTracks()
                   .forEach(track => track.stop());

        const devices = await navigator.mediaDevices.enumerateDevices();

        const videoDevices = devices.filter(x => x.kind === 'videoinput');
        
        const videoDeviceList = videoDevices.map(d => <li key={d.deviceId}>{d.label}</li>)

        videoDevices.forEach(x => console.log(x.getCapabilities()));

        console.log(devices)
        console.log(videoDevices);
        console.log(videoDeviceList);

        setVdDevices(videoDevices);

        const dxx = {};

        videoDevices.forEach(x => dxx[x.deviceId] = x.getCapabilities()); // {maxWidth: .width.max, maxHeight: x.getCapabilities().height.max});

        setDvcs(dxx);
      } catch (error) {
        console.error('Error fetching devices:', error);
      }
    };

    fetchData();
  }, []);

  useEffect(() => {
    if (!selectedVideoInput) {
      return;
    }

    setSelectedWidth(dvcs[selectedVideoInput].width.max);
    setSelectedHeight(dvcs[selectedVideoInput].height.max);
  }, [selectedVideoInput, dvcs]);

  useEffect(() => {
    setSelectedResolution(selectedWidth + ' x ' + selectedHeight);
  }, [selectedWidth, selectedHeight]);

  const startStream = useCallback(async () => {
    const kvmVideo = await navigator.mediaDevices.getUserMedia({
      video: {
        deviceId: { exact: selectedVideoInput },
        width: { exact: 1920 },
        height: { exact: 1080 }
      }});

      videoInputRef.current.srcObject = kvmVideo;
      // setStream(stream);
      // stream.getTracks().forEach((track) => track.stop());
  }, [selectedVideoInput]);

  const getPort = useCallback(async () => {
    try {
      // https://github.com/mik3y/usb-serial-for-android/blob/master/usbSerialExamples/src/main/res/xml/device_filter.xml
      // https://github.com/WICG/serial/issues/128#issuecomment-795870509
      // https://stackoverflow.com/questions/68194590/get-name-of-connected-device-in-web-serial-api-on-chrome
      const port = await navigator.serial.requestPort();
      await port.open({ baudRate: 9600 });

      setSerialPort(port);
  
      console.log(port);
      
      // info.usbVendorId
      // info.usbProductId
      console.log(port.getInfo());

      // clearToSend: true
      // dataCarrierDetect: true
      // dataSetReady: true
      // ringIndicator: true
      console.log(await port.getSignals());
    }
    catch (error) {
      console.error('Error fetching serial port:', error);
    }
  }, []);

  const derp = useCallback(() => {
    videoInputSelectRef.current.showPicker();
  }, []);

  const refreshPort = useCallback(async () => {
    try {
      if (serialPort) {
        if (serialPort.readable) {
          serialPort.close();
        }
        serialPort.forget();

        setSerialPort(null);
      }
      
      getPort();
    }
    catch (error) {
      console.error('Error fetching serial port:', error);
    }
  }, [serialPort, getPort]);

  const selectResolution = selected => {
    console.log(selected);
    const x = selected.split(' x ');
    console.log(x);
    setSelectedWidth(x[0]);
    setSelectedHeight(x[1]);
  }

  return (
    <div className="app">
      <div className="mb-3">
        <label htmlFor="videoInputStreamSelect" className="form-label">Email address</label>
        <select
          id="videoInputStreamSelect"
          ref={videoInputSelectRef}
          className="form-select"
          aria-label="Default select example"
          value={selectedVideoInput}
          onChange={e => setSelectedVideoInput(e.target.value)}
        >
          {vdDevices ? vdDevices.map(x => (<option key={x.deviceId} value={x.deviceId}>{x.label}</option>)) : null}
        </select>
      </div>
      {selectedVideoInput && (
        <div className="mb-3">
          <select
            className="form-select"
            aria-label="resolution"
            onChange={e => selectResolution(e.target.value)}
            value={selectedResolution}
          >
            {resolutionList(dvcs[selectedVideoInput].width.max, dvcs[selectedVideoInput].height.max, selectedResolution)}
          </select>
          <input type="number" min={dvcs[selectedVideoInput].width.min} max={dvcs[selectedVideoInput].width.max} value={selectedWidth} onChange={e => setSelectedWidth(e.target.value)} />
          <input type="number" min={dvcs[selectedVideoInput].height.min} max={dvcs[selectedVideoInput].height.max} value={selectedHeight} onChange={e => setSelectedHeight(e.target.value)}/>
        </div>)}
      <div className="mb-3">
        <label htmlFor="exampleFormControlTextarea1" className="form-label">Example textarea</label>
        <textarea className="form-control" id="exampleFormControlTextarea1" rows="3"></textarea>
      </div>
      <video ref={videoInputRef} autoPlay playsInline></video>
      <button onClick={startStream}>Start Video</button>
      <button onClick={refreshPort}>Get Port</button>
      <button onClick={derp}>derp</button>
      <span>{serialPort?.getInfo().usbVendorId} {serialPort?.getInfo().usbProductId}</span>
    </div>
  );
}

export default App;
